"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.useErrorHandler = useErrorHandler;
var react_1 = require("react");
var error_handler_1 = require("../utils/error-handler");
var toast_1 = require("../components/common/toast");
/**
 * Hook for handling errors consistently across the application
 */
function useErrorHandler() {
    var handleError = (0, react_1.useCallback)(function (error, options) {
        var _a = options || {}, _b = _a.showToast, showToast = _b === void 0 ? true : _b, _c = _a.toastType, toastType = _c === void 0 ? toast_1.EToastType.ERROR : _c, _d = _a.defaultMessage, defaultMessage = _d === void 0 ? "An unexpected error occurred" : _d, onError = _a.onError;
        var message = (0, error_handler_1.getErrorMessage)(error, defaultMessage);
        if (showToast) {
            toast_1.toastService.showToast(message, toastType);
        }
        if (onError) {
            onError(message);
        }
        // Log error in development
        if (process.env.NODE_ENV === "development") {
            console.error("Error handled:", error);
        }
        return message;
    }, []);
    var handleSuccess = (0, react_1.useCallback)(function (message) {
        toast_1.toastService.showToast(message, toast_1.EToastType.SUCCESS);
    }, []);
    var handleWarning = (0, react_1.useCallback)(function (message) {
        toast_1.toastService.showToast(message, toast_1.EToastType.WARNING);
    }, []);
    var handleInfo = (0, react_1.useCallback)(function (message) {
        toast_1.toastService.showToast(message, toast_1.EToastType.INFO);
    }, []);
    return {
        handleError: handleError,
        handleSuccess: handleSuccess,
        handleWarning: handleWarning,
        handleInfo: handleInfo,
    };
}
